// extracted by mini-css-extract-plugin
export default {"qaButton":"_80oRo81KqkZei6kQf4TKhQ=="};